import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import ViewAttachment from '../Reusable/ViewAttachment';
import Tooltip from '@material-ui/core/Tooltip';
import {
  uploadFileMaxSize,
  uploadFileDecisionTypeAllowedTypes,
  decisionTypeTypes,
} from '../../constants/globals.js';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class ModalForDecisionTypeUpdateAndPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      description: '',
      uploadedFile: '',
      type: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { decisionType } = this.props;
    this.setState({
      ...decisionType,
    });

    this.props.findDecisionTypeAttachment(decisionType.id);
  }

  onFileChange = (e) => {
    this.setState({
      uploadedFile: e.target.files.length > 0 && e.target.files[0],
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    if (!this.state.name) {
      errors['name'] = this.props.t.Errors.name;
      hasError = true;
    }

    if (this.state.uploadedFile) {
      if (
        !uploadFileDecisionTypeAllowedTypes.includes(
          this.state.uploadedFile.type
        )
      ) {
        errors['uploadedFile'] = this.props.t.Errors.invalidFileFormat;
        hasError = true;
      }
    }

    if (this.state.uploadedFile.size > uploadFileMaxSize) {
      errors['uploadedFile'] = this.props.t.Errors.invalidFileSize;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const updatedDecisionType = {
      ...this.props.decisionType,
      name: this.state.name,
      description: this.state.description,
    };

    if (this.state.uploadedFile) {
      let formData = new FormData();

      formData.append('file', this.state.uploadedFile);
      formData.append('name', this.state.uploadedFile.name);
      formData.append(
        'decisionType',
        new Blob([JSON.stringify(updatedDecisionType)], {
          type: 'application/json',
        })
      );
      this.props.handleUpdateDecisionTypeWithAttachment(
        formData,
        this.state.type
      );
    } else {
      this.props.updateDecisionType(updatedDecisionType, this.state.type);
    }
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({
      name: newValue.text,
      type: newValue.value,
    });
  };

  render() {
    const { error, format, t, isPreview, enums } = this.props || {},
      { Placeholders, Labels, Tooltips } = t || {},
      { DecisionTypeTypes } = enums || [];

    let fileTitlePreview;
    if (this.state.uploadedFile) {
      fileTitlePreview = this.state.uploadedFile.name;
    } else {
      fileTitlePreview = Labels.fileTitlePreview;
    }

    const uploadedFileTitle =
      this.state.uploadedFile.name || Labels.uploadDecision;

    const formStyle = isPreview ? 'preview-style' : '';

    let defValue;
    switch (this.props.decisionType?.type) {
      case decisionTypeTypes.DIGITAL_SIGNET.value:
        defValue = DecisionTypeTypes[0];
        break;
      case decisionTypeTypes.DIGITAL_SIGNET_AP.value:
        defValue = DecisionTypeTypes[2];
        break;
      case decisionTypeTypes.IMPRINT_SIGNET.value:
        defValue = DecisionTypeTypes[1];
        break;
      default:
        break;
    }

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title mb-4">{fileTitlePreview}</h5>
            <form onSubmit={this.handleSubmit}>
              <div disabled className={formStyle}>
                <div className="form-group">
                  <ComboBoxAutocomplete
                    data={DecisionTypeTypes}
                    text={(decisionType) => decisionType.text}
                    changeValue={(newValue) =>
                      this.changeComboAutocompleteValue('name', newValue)
                    }
                    wholeObject={true}
                    placeholder={Placeholders.name}
                    error={handleErrorMessage(
                      error,
                      'name',
                      this.state.errors.name
                    )}
                    updateValue={defValue}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <InputField
                    name="description"
                    placeholder={Placeholders.description}
                    onChange={this.onChange}
                    value={this.state.description}
                    multiline={true}
                    rows={3}
                    error={handleErrorMessage(
                      error,
                      'description',
                      this.state.errors.description
                    )}
                  />
                </div>

                {!isPreview && (
                  <div>
                    <div className="d-flex mt-4 mb-4">
                      <label
                        className="w-100 without-margin-bottom custom-file-upload"
                        style={{ cursor: 'pointer' }}
                      >
                        <input
                          type="file"
                          accept=".docx"
                          style={{ display: 'none' }}
                          onChange={this.onFileChange}
                        />
                        <Tooltip
                          title={Tooltips.editDecisionAttachment}
                          placement="top"
                          arrow={true}
                        >
                          <i className="fas fa-paperclip fa-2x" />
                        </Tooltip>
                        {uploadedFileTitle}
                        <i></i>
                      </label>
                      <hr className="lineBreaker" />
                    </div>
                    <div className="text-center">
                      {this.state.errors.uploadedFile && (
                        <b>
                          <div style={{ color: 'red' }}>
                            {this.state.errors.uploadedFile}
                          </div>
                        </b>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {this.props.decisionContent && format === 'docx' && (
                <ViewAttachment
                  content={this.props.decisionContent}
                  fileType={format}
                />
              )}
              {!isPreview && (
                <div className="row mt-4">
                  <ButtonSave onClick={this.handleSubmit} />
                </div>
              )}
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForDecisionTypeUpdateAndPreview,
  'ModalForDecisionTypeUpdateAndPreview'
);
